<template>
  <svg
    id="Clipboard-Share--Streamline-Ux.svg"
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    height="100"
    width="100"
  >
    <desc>
      Clipboard Share Streamline Illustration: https://streamlinehq.com
    </desc>
    <path
      d="M10 50a40 40 0 1 0 80 0 40 40 0 1 0 -80 0Z"
      fill="#d9edff"
      stroke-width="1"
    ></path>
    <path
      d="m26.826 18.024 41.344 0 0 54.022 -41.344 0Z"
      fill="#b0d9ff"
      stroke="#020064"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
    ></path>
    <path
      d="m31.787 21.331 31.421 0 0 46.305 -31.421 0Z"
      fill="#ffffff"
      stroke="#020064"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
    ></path>
    <path
      d="M51.6 16.921c0.007 -0.093 0.028 -0.181 0.028 -0.276a4.135 4.135 0 0 0 -8.269 0c0 0.095 0.022 0.183 0.028 0.276H38.4a1.1 1.1 0 0 0 -1.1 1.1v4.41a1.1 1.1 0 0 0 1.1 1.1h18.193a1.1 1.1 0 0 0 1.1 -1.1v-4.41a1.1 1.1 0 0 0 -1.1 -1.1Z"
      fill="#ffffff"
      stroke="#020064"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
    ></path>
    <path
      d="M34.819 83.21a12.127 1.654 0 1 0 24.254 0 12.127 1.654 0 1 0 -24.254 0Z"
      fill="#b0d9ff"
      stroke-width="1"
    ></path>
    <path
      d="M45.936 58.282a18.713 18.713 0 1 0 37.426 0 18.713 18.713 0 1 0 -37.426 0Z"
      fill="#ffffff"
      stroke="#020064"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
    ></path>
    <path
      d="M74.021 65.131a4.334 4.334 0 0 0 -7.5 -2.962l-5.143 -2.5a4.481 4.481 0 0 0 0 -3.524l5.143 -2.5a4.333 4.333 0 1 0 -1.17 -2.961 2.4 2.4 0 0 0 0.014 0.317l-6.14 2.977a4.253 4.253 0 0 0 -1.82 -0.405 4.334 4.334 0 1 0 0 8.668 4.239 4.239 0 0 0 1.82 -0.405l6.14 2.976a2.44 2.44 0 0 0 -0.014 0.319 4.334 4.334 0 0 0 8.668 0Z"
      fill="#b0d9ff"
      stroke="#020064"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1"
    ></path>
  </svg>
</template>
